import React from "react";
import { Layout } from "antd";
import Footer from "./footer";
import Header from "./navbar";
const { Content } = Layout;

export default function MemberLayout(appProps) {
  return (
    <Layout>
      <Header className="header" {...appProps} />
      <Layout className="app">
        <Content className="site-layout-background member-layout">
          {appProps.children}
        </Content>
      </Layout>
      <Footer />
    </Layout>
  );
}
